import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAccountCircle = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconAccountCircle",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M234-276q51-39 114-61t132-23 132 23 114 61q35-41 55-93t19-111q0-133-93-226t-227-94-226 94-94 226q0 59 20 111t54 93m246-164q-59 0-99-40t-41-100 41-99 99-41 100 41 40 99-40 100-100 40m0 360q-83 0-156-31t-127-86-85-127-32-156 32-156 85-127 127-85 156-32 156 32 127 85 86 127 31 156-31 156-86 127-127 86-156 31"
  })
}));
IconAccountCircle.displayName = 'IconAccountCircle';